/**
 * @module builder
 */
import type { Payment, QuoteDocument } from 'paintscout'
import { getPayments } from '../get-payments'
import { isValidPaymentRequest } from '../is-valid-payment-request'

/**
 * @param quote
 * @param previewPayment payment currently being requested
 * @returns The payment requests to display in the PaymentRequestDialog's preview component
 */
export default function getRequestedPaymentsForPreview(args: {
  quote: QuoteDocument
  previewPayment?: Payment
}): Payment[] {
  const { quote, previewPayment } = args
  const payments = getPayments({ quote })

  // non-pending payments (processing/paid) are kept so the preview reflects processing state
  const requests = payments
    ? [...payments].filter((payment) => payment.status !== 'pending' || isValidPaymentRequest({ quote, payment }))
    : []

  if (!!previewPayment && isValidPaymentRequest({ quote, payment: previewPayment })) {
    return requests.find((p) => p.id === previewPayment.id) ? requests : [...requests, previewPayment]
  }

  return requests
}
